import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import Subject from "./routes/Subject";
export default store => ({
  path: "subjects",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "subjects" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [Subject(store)],
});
